class ConditionalLineItemProperties {
  constructor() {
    this.form = document.querySelector('form[data-product-form]');
    this.conditionalProperties = document.querySelectorAll('.line-item-property[data-conditional-option]');
    
    if (this.form && this.conditionalProperties.length > 0) {
      this.init();
    }
  }

  init() {
    // Écouter les changements de variant via l'événement du thème
    this.form.addEventListener('variant:change', (event) => {
      this.updateConditionalProperties(event.detail.variant);
    });

    // Écouter aussi les changements de variant via le variant-picker
    const variantPickers = document.querySelectorAll('variant-picker');
    variantPickers.forEach(picker => {
      picker.addEventListener('variant:change', (event) => {
        this.updateConditionalProperties(event.detail.variant);
      });
    });

    // Écouter les changements directs sur les sélecteurs de variant
    const variantSelectors = this.form.querySelectorAll('input[name^="option"]');
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', (event) => {
        // Récupérer la variante actuelle depuis le formulaire
        const variantId = this.form.querySelector('input[name="id"]').value;
        const variant = this.getVariantById(variantId);
        if (variant) {
          this.updateConditionalProperties(variant);
        }
      });
    });
  }

  updateConditionalProperties(variant) {
    this.conditionalProperties.forEach(property => {
      const optionName = property.dataset.conditionalOption;
      const expectedValue = property.dataset.conditionalValue;
      
      // Vérifier si la variante a l'option attendue
      const shouldShow = this.checkVariantOption(variant, optionName, expectedValue);
      
      if (shouldShow) {
        property.style.display = '';
        // Réactiver les champs required - les champs conditionnels sont toujours required quand visibles
        const inputs = property.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
          // Si c'est un champ conditionnel, il doit être required quand visible
          input.required = true;
        });
      } else {
        property.style.display = 'none';
        // Désactiver les champs required et vider les valeurs
        const inputs = property.querySelectorAll('input, select, textarea');
        inputs.forEach(input => {
          input.required = false;
          input.value = '';
        });
      }
    });
  }

  checkVariantOption(variant, optionName, expectedValue) {
    if (!variant || !variant.options) return false;
    
    // Trouver l'index de l'option dans le produit
    const product = this.getProductData();
    const optionIndex = product.options ? 
      product.options.findIndex(option => option === optionName) : -1;
    
    if (optionIndex === -1) return false;
    
    // Vérifier si la valeur de la variante correspond
    return variant.options[optionIndex] === expectedValue;
  }

  getVariantById(variantId) {
    const product = this.getProductData();
    return product.variants ? 
      product.variants.find(variant => variant.id.toString() === variantId.toString()) : null;
  }

  getProductData() {
    // Récupérer les données du produit depuis le variant-picker
    const variantPicker = document.querySelector('variant-picker');
    if (variantPicker) {
      const variantScript = variantPicker.querySelector('script[data-variant]');
      if (variantScript) {
        try {
          const variant = JSON.parse(variantScript.textContent);
          // Récupérer les options du produit depuis les éléments du variant-picker
          const options = [];
          const optionElements = variantPicker.querySelectorAll('.variant-picker__option');
          optionElements.forEach(optionElement => {
            const legend = optionElement.querySelector('legend');
            if (legend) {
              const optionName = legend.textContent.replace(':', '').trim();
              options.push(optionName);
            }
          });
          
          return {
            options: options,
            variants: [variant] // Pour simplifier, on utilise juste la variante actuelle
          };
        } catch (e) {
          console.error('Erreur lors du parsing des données de variante:', e);
        }
      }
    }
    
    return { options: [], variants: [] };
  }
}

// Initialiser quand le DOM est prêt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ConditionalLineItemProperties();
  });
} else {
  new ConditionalLineItemProperties();
}

// Exporter la classe pour une utilisation externe si nécessaire
export { ConditionalLineItemProperties }; 